import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Product } from '../../../../../../../../../models/interface/product/product';
import { FtthService } from '../../../../../../../../../services/api/ftth/ftth.service';
import saveAs from 'file-saver';
import { TranslateService } from '@ngx-translate/core';
import { NotificationLevel, NotificationsService } from 'src/app/services/api/notifications/notifications.service';
import { ProductDepthLevelCfsActionsComponent } from '../product-depth-level-cfs-actions.component';

@Component({
  selector: 'app-validate-cto',
  templateUrl: './validate-cto.component.html',
  styleUrls: ['./validate-cto.component.scss']
})
export class ValidateCtoComponent implements OnInit {

  loading: boolean;
  resultado: any;
  tests: any[] = [
    { nameId: 'TST_FTTH_DATOS', name: 'Test de consulta de datos', tv: false, corporate: false, wholesales: false},
    { nameId: 'TST_FTTH_CONF_EMP', name: 'Test de configuración', tv: false, corporate: false, wholesales: false },
    { nameId: 'TST_FTTH_OSTATE', name: 'Consulta Estado Óptico', tv: false, corporate: false, wholesales: false },
    { nameId: 'TST_FTTH_STATE_ONT', name: 'Consulta Estado ONT', tv: false, corporate: false, wholesales: false },
    { nameId: 'TST_FTTH_RESET_ONT', name: 'Reseteo ONT', tv: false, corporate: false, wholesales: false },
    { nameId: 'TST_RAMA_BS', name: 'Test de RAMA BitStream', tv: false, corporate: false, wholesales: false },
    { nameId: 'TST_FTTH_ONT_OLT', name: 'Verificación de Configuración ONT en OLT', tv: false, corporate: false, wholesales: false },
    { nameId: 'TST_ESTADO_PON', name: 'Consulta Estado PON', tv: false, corporate: false, wholesales: false },
    { nameId: 'TST_FTTH_PON', name: 'Diagnóstico PON', tv: false, corporate: false, wholesales: false },
    { nameId: 'TST_FTTH_COR_VLAN', name: 'Consulta VLANs', tv: false, corporate: true, wholesales: false },
    { nameId: 'TST_FTTH_TV_ACTIVE_CHANNELS', name: 'Consulta de canales activos por ONT', tv: true, corporate: false, wholesales: false },
    { nameId: 'TST_FTTH_TV_STATS_IGMP', name: 'Consulta de estadísticas por ONT', tv: true, corporate: false, wholesales: false },
    { nameId: 'TST_FTTH_TV_RESET_STATS_IGMP', name: 'Reseteo de estadísticas IGMP por ONT', tv: true, corporate: false, wholesales: false },
    { nameId: 'TST_FTTH_TV_STATS_IGMP_SNOOP', name: 'Consultar estadísticas de IGMP', tv: true, corporate: false, wholesales: false },
    { nameId: 'TST_FTTH_TV_CHECK_OLT', name: 'Verificación de la configuración IGMP en la OLT', tv: true, corporate: false, wholesales: false },
    { nameId: 'TST_ESTADO_CTO', name: 'Verificación de productos sin servicio sobre una CTO', tv: false, corporate: false, wholesales: false },
    { nameId: 'TST_FTTH_AFECTADO_MASIVA', name: 'Afectado por masiva', tv: false, corporate: false, wholesales: true },
    { nameId: 'TST_FTTH_AUTOFIND', name: 'Autofind ONT', tv: false, corporate: false, wholesales: false, orange: true }
  ];

  constructor(
    private ftthService: FtthService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<ProductDepthLevelCfsActionsComponent>,
    private notificationsService: NotificationsService,
    private translateService: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: {
      item: Product;
      serviceId: number;
      type: string;
      ino: string;
      testOk: boolean;
      resultado: any;
      testName: string;
    }
  ) {
  }

  ngOnInit() {
    this.loading = false;
  }

  test(test: any) {
    this.loading = true;
    this.ftthService.test(this.data.item.cfses[0].serviceId, test.nameId, this.data.item.origin, this.data.ino).subscribe(
      result => {
        this.resultado = result;
        if (this.resultado.conclusion.includes('OK')) {
          const dialogRef = this.dialog.open(ValidateCtoComponent, {
            data: {
              testOk: true,
              resultado: result,
              testName: test.name
            },
          });
        } else {
          const dialogRef = this.dialog.open(ValidateCtoComponent, {
            data: {
              testOk: false
            },
          });
        }
        this.notificationsService.showNotification(this.translateService.instant('TEST.success'), NotificationLevel.SUCCESS);
        this.loading = false;
        this.dialogRef.close();
      },
      error => {
        this.notificationsService.showNotification(this.translateService.instant('TEST.error'), NotificationLevel.ERROR);
        this.loading = false;
        this.dialogRef.close();
      });
  }

  downloadFile() {
    const headers = {
      id: 'Name',
      nombre: 'Value'
    };

    this.exportCSVFile(headers, this.data.resultado.resultado.datos.outputParam, 'resultadoTest');
    const blob = new Blob([headers.toString()], { type: 'text/csv' });
  }

  exportCSVFile(headers, items, fileName) {
    if (headers) {
      items.unshift(headers);
    }

    const jsonObject = JSON.stringify(items);

    const csv = this.convertToCSV(jsonObject);

    const exportName = fileName + '.csv' || 'export.csv';

    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, exportName);
  }

  convertToCSV(objArray) {
    const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;

    let str = '';

    for (let i = 0; i < array.length; i++) {
      let line = '';
      for (let index in array[i]) {
        if (line != '') {
          line += ',';
        }
        line += array[i][index];
      }
      str += line + '\r\n';
    }
    return str;
  }

  testsFiltrados(tests: any[]): any[] {
    let testsFiltrados = [];
    if (this.data.item.template.includes('TV')) {
      testsFiltrados = (tests.filter(
        (test => (test.tv === false && test.corporate === false && test.wholesales === false) || (test.tv === true && test.corporate === false && test.wholesales === false))
      ));
    } else if (this.data.item.specId.includes('Business') || this.data.item.specId.includes('Corporate')) {
        testsFiltrados = (testsFiltrados = tests.filter(
          (test => (test.tv === false && test.corporate === false && test.wholesales === false) || (test.tv === false && test.corporate === true && test.wholesales === false))
        ));
    } else {
      testsFiltrados = (testsFiltrados = tests.filter(
        (test => (test.tv === false && test.corporate === false && test.wholesales === false))
      ));
    }
    if (this.data.item.specId.includes('Wholesale')) {
      testsFiltrados = testsFiltrados.concat(tests.filter(test => (test.wholesales === true)));
    }
    // Filtrar tests exclusivos de Orange (INO 989)
    if (this.data.ino !== '989') {
      testsFiltrados = testsFiltrados.filter(test => !test.orange);
    }
    return testsFiltrados;
  }

  cerrarDialog() {
    this.dialogRef.close();
  }

}
